import { Button, ButtonSize } from '@atlas/components';
import cx from 'classnames';
import { useParams, useSearchParams } from 'wouter';

import DepositButton from 'components/DepositButton';
import FavoriteButton from 'components/FavoriteButton';
import Icon from 'components/Icon/Icon';
import { AuthStatus, useClientProfile } from 'store';
import type { CasinoGroupPathParam } from 'utils/casino';
import { Translation } from 'utils/translations';

import styles from './CasinoGameBottomMenu.module.scss';

const CasinoGameBottomMenu = () => {
  const params = useParams<{ gameId: string; group: CasinoGroupPathParam }>();
  const gameId = +params.gameId;
  const [searchParams, setSearchParams] = useSearchParams();
  const isDemo = searchParams.get('demo') === 'true';
  const [{ status }] = useClientProfile();
  const isLoggedIn = status === AuthStatus.signedIn;

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <FavoriteButton gameId={gameId} />
        {isDemo && (
          <div className={styles['demo-button-wrapper']}>
            <Button
              size={ButtonSize.medium}
              data-testid="demo-mode-button"
              onClick={() => {
                setSearchParams((prev) => {
                  prev.delete('demo');

                  return prev;
                });
              }}
              icon={<Icon name="play.outline" width={24} height={24} />}
            >
              <Translation message="demo_mode_button" />
            </Button>
          </div>
        )}
      </div>
      {isLoggedIn && (
        <DepositButton>
          <button
            data-testid="deposit-button"
            type="button"
            className={cx(styles['button-icon'], styles.deposit)}
          >
            <Icon name="wallet-add.bold" width={24} height={24} />
            <Translation message="deposit" />
          </button>
        </DepositButton>
      )}
    </div>
  );
};

export default CasinoGameBottomMenu;
